import React from 'react';
import { FormLayoutComposer, IFormLayoutProps } from 'components/common/form/renderer/FormLayoutComposer';
import { ActAfterSaveSuccess } from 'components/common/form/act';

export default function ExternalReferenceFilterForm(props: IFormLayoutProps) {
    props.hookForm.form.formAct.overrideAct(
        'afterSaveSuccess',
        class extends ActAfterSaveSuccess {
            async exec(response: any, data: any): Promise<any> {
                if (props.hookForm.form.hookFormGetValues('refreshList') == 1) {
                    props.hookForm.form.hookFormSetValue('refreshList', 0, { shouldDirty: false });
                    for (const [key, value] of Object.entries(data)) {
                        const currentValue = props.hookForm.form.hookFormGetValues(key);
                        if (typeof currentValue != 'undefined' && currentValue != value) {
                            props.hookForm.form.hookFormSetValue(key, value, { shouldDirty: false });
                        }
                    }
                    props.hookForm.form.hookFormReset(
                        { ...data, refreshList: 0 },
                        { keepValues: true, keepDefaultValues: false },
                    );
                    props.hookForm.form.hookFormSetValue('refreshList', 0, { shouldDirty: false });
                    return Promise.resolve(response);
                } else {
                    return super.exec(response, data);
                }
            }
        },
    );

    return <FormLayoutComposer props={props} />;
}
